<template>
    <el-container>
        <el-main>
            <el-row :gutter="10">
                <el-col v-for="(item, index) in houseList" :key="index" :xs="24" :sm="12" :lg="8">
                    <el-card shadow="always" class="box-card">
                        <template #header>
                            <div class="card-header">
                                <span> {{ item.title }} </span>
                            </div>
                        </template>
                        <el-descriptions :column="1" class="margin-top" border>
                            <el-descriptions-item label="房间状态">
                                <el-tag type="success" v-if="item.room_status === 0">空闲中</el-tag>
                                <el-tag type="danger" v-if="item.room_status === 1">使用中</el-tag>
                                <el-tag type="warning" v-if="item.room_status === 2">保洁中</el-tag>
                                <el-button size="small" style="margin-left: 10px" v-if="item.room_status !== 1" type="primary" @click="toAddOrder(item)">代客下单</el-button>
                                <el-button size="small" style="margin-left: 10px" v-if="item.room_status === 1 || item.room_status === 2" type="primary" @click="toCotinues(item)">续单</el-button>
                            </el-descriptions-item>
                            <el-descriptions-item label="可用时间段">
                                <template v-for="(item, index) in item.times" :key="index">
                                    <el-tag v-if="item.is_show" :type="item.is === 1 ? 'success' : 'danger'">
                                        {{ item.h }}
                                    </el-tag>
                                </template>
                            </el-descriptions-item>
                            <el-descriptions-item :span="1" label="房门">
                                <div class="flex">
                                    <template v-for="(device, index) in item.devices" :key="index">
                                        <template v-if="device.groups == 'lock'">
                                            <el-tag v-if="device.is_online" type="primary">在线</el-tag>
                                            <el-tag v-else type="danger">离线</el-tag>

                                            <el-button size="small" style="margin-left: 10px" type="primary" v-if="device.device_brand === 2" @click="deviceSet(device, 2)">开门</el-button>
                                            <template v-else>
                                                <el-button size="small" style="margin-left: 10px" type="primary" @click="deviceSet(device, 1)">开门</el-button>
                                                <el-tag type="primary">电量：{{device.lock_battery}} %</el-tag>
                                            </template>
                                        </template>
                                    </template>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item :span="1" label="智能开关">
                                <div class="flex">
                                    <template v-for="(device, index) in item.devices" :key="index">
                                        <template v-if="device.groups == 'switch'">
                                            <el-tag type="primary" v-if="device.is_online">在线</el-tag>
                                            <el-tag type="danger" v-else>离线</el-tag>
                                            <template v-if="device.device_brand === 2">
                                                <el-tag type="success" style="margin-left: 10px" v-if="device.socket_power == 1">通电</el-tag>
                                                <el-tag type="warning" style="margin-left: 10px" v-else>断电</el-tag>

                                                <el-button size="small" style="margin-left: 10px" type="danger" v-if="device.socket_power == 1" @click="deviceSet(device, 0, device.line)">关闭</el-button>
                                                <el-button size="small" style="margin-left: 10px" type="primary" v-else @click="deviceSet(device, 1, device.line)">开启</el-button>
                                            </template>
                                            <template v-else>
                                                <el-tag type="success" style="margin-left: 10px" v-if="device['switch_power'+device.line] == 1">通电</el-tag>
                                                <el-tag type="warning" style="margin-left: 10px" v-else>断电</el-tag>

                                                <el-button size="small" style="margin-left: 10px" type="danger" v-if="device['switch_power'+device.line] == 1" @click="deviceSet(device, 0, device.line)">关闭</el-button>
                                                <el-button size="small" style="margin-left: 10px" type="primary" v-else @click="deviceSet(device, 1, device.line)">开启</el-button>
                                            </template>

                                        </template>
                                    </template>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item :span="1" label="智能插座">
                                <div class="flex">
                                    <template v-for="(device, index) in item.devices" :key="index">
                                        <template v-if="device.groups == 'socket'">
                                            <el-tag type="primary" v-if="device.is_online">在线</el-tag>
                                            <el-tag type="danger" v-else>离线</el-tag>

                                            <el-tag type="success" style="margin-left: 10px" v-if="device.socket_power == 1">通电</el-tag>
                                            <el-tag type="warning" style="margin-left: 10px" v-else>断电</el-tag>

                                            <el-button size="small" style="margin-left: 10px" type="danger" v-if="device.socket_power == 1" @click="deviceSet(device, 0)">关闭</el-button>
                                            <el-button size="small" style="margin-left: 10px" type="primary" v-else @click="deviceSet(device, 1)">开启</el-button>
                                        </template>
                                    </template>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>
                </el-col>

                <el-col :xs="24" :sm="12" :lg="8">
                    <el-card shadow="always" class="box-card">
                        <template #header>
                            <div class="card-header">
                                <span> 店铺其他设备 </span>
                            </div>
                        </template>
                        <el-descriptions :column="1" class="margin-top" border>
                            <el-descriptions-item label="大门">
                                <el-button size="small" @click="openGate">开大门</el-button>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>
                </el-col>
            </el-row>
        </el-main>
        <addorder ref="addOrderRef" @update:addorder="getInfo" :house-info="houseInfo"></addorder>
        <continues ref="continuesRef" @update:addorder="getInfo" :house-info="houseInfo"></continues>
    </el-container>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, computed } from 'vue'
    import { useOtherStore } from '@/store'
    import Cache from '@/utils/cache'
    import { Host } from '@/config/index'
    import Addorder from '../components/addorder'
    import Continues from '../components/continues'

    export default defineComponent({
        components: {
            Addorder,
            Continues
        },
        setup(props, context) {
            const { proxy } = getCurrentInstance()

            const StoreOther = useOtherStore()

            const houseList = ref([])
            const houseInfo = ref({})
            const addOrderRef = ref()

            const getInfo = () => {
                let url = `${Host}store/shared/index/index`
                proxy.jiu.request(url).then((res, rej) => {
                    houseList.value = res.data
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }
            getInfo()

            const deviceSet = (info, type, line = 0) => {
                let data = {
                    type: type,
                    id: info.id,
                    gateway: info.gateway_title
                }
                if (line !== 0) data['line'] = line

                postSet(data)
            }

            const postSet = (data) => {
                let url = `${Host}store/shared/house/set_device`
                proxy.jiu.request(url, data, 'POST').then((res, rej) => {
                    proxy.jiu.toast(res.message)
                    setTimeout(() => {
                        getInfo()
                    }, 2000)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }
            const toAddOrder = (item) => {
                houseInfo.value = item
                addOrderRef.value.add(item)
            }
            const continuesRef = ref()
            const toCotinues = (item) => {
                houseInfo.value = item
                continuesRef.value.add(item)
            }

            const openGate = () => {
                let url = `${Host}store/shared/index/open_gate`
                proxy.jiu.request(url, {}, 'GET').then((res, rej) => {
                    proxy.jiu.toast(res.message)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }
            return {
                houseList,
                houseInfo,

                addOrderRef,
                getInfo,
                toAddOrder,
                deviceSet,

                continuesRef,
                toCotinues,

                openGate
            }
        }
    })

</script>

<style>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.box-card .is-bordered-label{
    width: 170px;
}
</style>
